import classNames from 'classnames';
import { ForwardedRef, forwardRef } from 'react';

import BasicButton, { BasicButtonElement, BasicButtonProps } from './BasicButton';

import styles from '../../styles/buttons/rounded-button.module.css';

interface RoundedButtonProps extends BasicButtonProps {
    compact?: boolean;
    transparent?: boolean;
    buttonRef?: ForwardedRef<BasicButtonElement>;
}

function RoundedButtonBase({
    transparent = false,
    compact = false,
    className,
    buttonRef,
    ...props
}: RoundedButtonProps) {
    return (
        <BasicButton
            className={classNames([
                styles.container,
                {
                    [styles.transparent]: transparent,
                    [styles.compact]: compact,
                    [className]: className !== null,
                },
            ])}
            ref={buttonRef}
            {...props}
        />
    );
}

export default forwardRef<BasicButtonElement, Omit<RoundedButtonProps, 'buttonRef'>>(
    function RoundedButton(props, ref) {
        return <RoundedButtonBase {...props} buttonRef={ref} />;
    },
);
